export default __webpack_public_path__ + "static/media/3t.aa89edc2.jpg";